<div (click)="$event.stopPropagation()">
  <span class="tiny-text block">Bruger: {{ user }}</span>
  <span class="tiny-text block">Portal: {{ pVer }}</span>
  <span class="tiny-text block">Service: {{ sVer }}</span>
  <span class="tiny-text block">Miljø: {{ environment }}</span>
</div>
